import { ReactElement, useState } from 'react';
import EmailInput from '@components/FormFields/EmailInput';
import TextInput from '@components/FormFields/TextInput';
import Button from '@components/DesignLibrary/Button';
import Spacer from '@components/Spacer';
import s from './AddUserWorkflowCollaboratorForm.module.scss';

type Props = {
  isSubmitting: boolean,
  isAssign?: boolean,
  onSubmit: (name: string, email: string) => void;
};

const AddUserWorkflowCollaboratorForm = ({ onSubmit, isSubmitting, isAssign }: Props): ReactElement => {
  const [email, setEmail] = useState<string>('');
  const [name, setName] = useState<string>('');
  const [emailError, setEmailError] = useState<string | null>(null);
  const [nameError, setNameError] = useState<string | null>(null);

  const handleSubmit = (): void => {
    if (emailError || nameError) {
      return;
    }
    onSubmit(name, email);
  };

  return (
    <div className={s.addCollaborator}>
      <TextInput
        id={'name'}
        value={name}
        onChange={setName}
        label={'Name'}
        placeholder={`Enter collaborator's name`}
        autoComplete={'name'}
        onError={setNameError}
        required
      />
      <Spacer size={12}/>
      <EmailInput
        id="email"
        error={emailError}
        value={email}
        onChange={setEmail}
        onError={setEmailError}
        label="Email"
        required
        placeholder={`Enter collaborator's email`}
      />
      <Spacer size={12}/>
      <Button variant='primary' size='md' fullWidth onClick={handleSubmit} loading={isSubmitting}>
        {isAssign ? 'Assign' : 'Add collaborator'}
      </Button>
    </div>
  );
};

export default AddUserWorkflowCollaboratorForm;
